export default __webpack_public_path__ + "static/media/process-bg.384eab03.png";